import { Atom } from 'AppReact';
import styled, { keyframes } from "styled-components";

export const grow = keyframes`
  0% {
    transform: translate(0px, 0px);
  }

  40% {
    transform: translate(0px, 0px);
  }

  100% {
    transform: translate(400px, 0px);
  }
`;

const template = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;

  svg {
    width: 62px;
    height: 40px;
    animation: ${grow} 1000ms ease-in-out 0s forwards;;  
  }
`;


export default Atom({ type: 'label', dataType: 'object', template })